var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 2.29199C5.74276 2.29199 2.29163 5.74313 2.29163 10.0003C2.29163 14.2575 5.74276 17.7087 9.99996 17.7087C14.2572 17.7087 17.7083 14.2575 17.7083 10.0003C17.7083 5.74313 14.2572 2.29199 9.99996 2.29199ZM1.04163 10.0003C1.04163 5.05277 5.05241 1.04199 9.99996 1.04199C14.9475 1.04199 18.9583 5.05277 18.9583 10.0003C18.9583 14.9479 14.9475 18.9587 9.99996 18.9587C5.05241 18.9587 1.04163 14.9479 1.04163 10.0003Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.04199C10.3452 6.04199 10.625 6.32181 10.625 6.66699V10.0003C10.625 10.3455 10.3452 10.6253 10 10.6253C9.65482 10.6253 9.375 10.3455 9.375 10.0003V6.66699C9.375 6.32181 9.65482 6.04199 10 6.04199Z",
    fill: "#EB3E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 13.333C9.375 12.9878 9.65482 12.708 10 12.708H10.0083C10.3535 12.708 10.6333 12.9878 10.6333 13.333C10.6333 13.6782 10.3535 13.958 10.0083 13.958H10C9.65482 13.958 9.375 13.6782 9.375 13.333Z",
    fill: "#EB3E3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.fa7fb592.svg";
export { ForwardRef as ReactComponent };